import React from "react";
import PropTypes from "prop-types";

import messages from "../../assets/i18n";
import { useSelector } from "react-redux";

function SelectGate (props) {

    const lang = useSelector(state => state.language.name);

    const setGate = gate => {
        const { setGateFuncCallback } = props;
        if (setGateFuncCallback !== undefined) {
            setGateFuncCallback(gate);
        }
    };


    const { gates } = props;

    if (gates === undefined) {
        return <h3>{messages[lang].noGateHasBeenPassed}</h3>;
    } else if (gates.length <= 0) {
        return <h3>{messages[lang].noGatesAvaliable}</h3>;
    } else {
        return (
            <div className="selectGate">
                {gates.map((gate, i) => {
                    const active = props.selectedGateFromParent  === gate.idPortao ? "active" : "";
                    return (
                        <button
                            key={i}
                            id={`select_gate_gate_button_${gate.nomePortao.replace(" ","")}`}
                            type="buttom"
                            className={`btn ${active}`}
                            onClick={() => setGate(gate.idPortao)}
                        >
                            <span>{gate.nomePortao}</span>
                        </button>
                    );
                })}
            </div>
        );
    }
}
export default SelectGate;

SelectGate.propTypes = {
    gates: PropTypes.array.isRequired,
    selectedGateFromParent: PropTypes.number,
    setGateFuncCallback: PropTypes.func.isRequired
};
